module.exports = __webpack_public_path__ + "img/Icons_Globe.672abc15.png";